export const periodMapper = (period: string): number => {
    const duration = {
        "15Days": 1,
        "1Month": 2,
        "2Months": 3,
        "3Months": 4,
        "4Months": 5,
        "5Months": 6,
        "6Months": 7,
        "7Months": 8,
        "8Months": 9,
        "9Months": 10,
        "10Months": 11,
        "11Months": 12,
        "12Months": 13,
        "21Days": 14,
    }
    return duration[period as keyof typeof duration];
}

export const dperiodMapper = (period: string): DPeriod => {
    const duration = {
        "15Days": DPeriod.DPeriod_1,
        "1Month": DPeriod.DPeriod_2,
        "2Months": DPeriod.DPeriod_3,
        "3Months": DPeriod.DPeriod_4,
        "4Months": DPeriod.DPeriod_5,
        "5Months": DPeriod.DPeriod_6,
        "6Months": DPeriod.DPeriod_7,
        "7Months": DPeriod.DPeriod_8,
        "8Months": DPeriod.DPeriod_9,
        "9Months": DPeriod.DPeriod_10,
        "10Months": DPeriod.DPeriod_11,
        "11Months": DPeriod.DPeriod_12,
        "12Months": DPeriod.DPeriod_13,
        "21Days": DPeriod.DPeriod_14,
    }
    return duration[period as keyof typeof duration];
}

// Copied function from Sagacity (Java) to TypeScript
export function transliterateAddressFromCyrillic(cyrillicText: string | null, addSpace: boolean): string {
    if (cyrillicText === null) {
        return "";
    }

    const cyrillic = [
        "'", "’", "а", "б", "в", "г", "ґ", "д", "е", "є", "ж", "з", "и", "і", "ї", "й",
        "к", "л", "м", "н", "о", "п", "р", "с", "т", "у", "ф", "х", "ц", "ч", "ш", "щ", "ь", "ю", "я",
        "А", "Б", "В", "Г", "Ґ", "Д", "Е", "Є", "Ж", "З", "И", "І", "Ї", "Й", "К", "Л", "М", "Н",
        "О", "П", "Р", "С", "Т", "У", "Ф", "Х", "Ц", "Ч", "Ш", "Щ", "Ю", "Я"
    ];

    const latin = [
        "", "", "a", "b", "v", "h", "g", "d", "e", "ie", "zh", "z", "y", "i", "i", "i",
        "k", "l", "m", "n", "o", "p", "r", "s", "t", "u", "f", "kh", "ts", "ch", "sh", "shch", "", "iu", "ia",
        "A", "B", "V", "H", "G", "D", "E", "Ye", "Zh", "Z", "Y", "I", "Yi", "Y", "K", "L", "M", "N",
        "O", "P", "R", "S", "T", "U", "F", "Kh", "Ts", "Ch", "Sh", "Shch", "Yu", "Ya"
    ];

    // Map of patterns to replace
    const transliterateNamingMap: { [key: string]: string } = {
        "місто": "city",
        "м\\.?\\s": "city ",
        "смт\\.?\\s": "twp. ",
        "селище": "village",
        "село": "village",
        "с\\.?\\s": "village ",
        "вулиця": "str.",
        "вул\\.?\\s": "str. ",
        "проспект": "avenue",
        "просп\\.?\\s": "avenue ",
        "бульвар": "blvd.",
        "бул\\.?\\s": "blvd. ",
        "бульв\\.?\\s": "blvd. ",
        "узвіз": "ds. ",
        "провулок": "lane",
        "пров\\.?\\s": "lane ",
        "шосе": "road",
        "ш\\.?\\s": "road ",
        "масив": "massif",
        "мас\\.?\\s": "massif ",
        "мікрорайон": "microdistr.",
        "мкр-н": "microdistr. ",
        "площа": "area",
        "пл\\.?\\s": "area ",
        "майдан": "square",
        "майд\\.?\\s": "square ",
        "перехрестя": "crossing",
        "пер\\.?\\s": "crossing ",
        "квартал": "borough",
        "кварт\\.?\\s": "borough ",
        "селище міського типу": "twp.",
        "квартира": "flat",
        "кв\\.?\\s": "flat ",
        "корпус": "housing",
        "корп\\.?\\s": "housing ",
        "офіс": "office",
        "оф\\.?\\s": "office "
    };

    cyrillicText = cyrillicText.replace("селище міського типу", "twp.");

    // Replace all patterns in the map
    for (const pattern in transliterateNamingMap) {
        const replacement = transliterateNamingMap[pattern];
        const regex = new RegExp(pattern, "g");
        cyrillicText = cyrillicText?.replace(regex, replacement);
    }

    let result = "";
    const words = cyrillicText.split(" ");
    for (let word of words) {
        for (let char of word) {
            let found = false;
            // Check if the character is in the cyrillic alphabet
            for (let i = 0; i < cyrillic.length; i++) {
                if (char === cyrillic[i]) {
                    result += latin[i];
                    found = true;
                    break;
                }
            }
            if (!found) {
                result += char;
            }
        }
        if (addSpace) {
            result += " ";
        }
    }

    return result.trim()
}

export const cyryllicToLatin = (text: string) => {
    const cyrillic = ["А", "Б", "В", "Г", "Д", "Е", "Є", "Ж", "З", "И", "І", "Ї", "Й", "К", "Л", "М", "Н", "О", "П", "Р", "С", "Т", "У", "Ф", "Х", "Ц", "Ч", "Ш", "Щ", "Ь", "Ю", "Я", "а", "б", "в", "г", "д", "е", "є", "ж", "з", "и", "і", "ї", "й", "к", "л", "м", "н", "о", "п", "р", "с", "т", "у", "ф", "х", "ц", "ч", "ш", "щ", "ь", "ю", "я", " ", ".", ",", ":", ";", "!", "?", "(", ")", "-", "_", "+", "=", "*", "/", "%", "#", "@", "$", "&", "^", "№", "1", "2", "3", "4", "5", "6", "7", "8", "9", "0"];
    const latin = ["A", "B", "V", "H", "D", "E", "E", "Zh", "Z", "Y", "I", "I", "Y", "K", "L", "M", "N", "O", "P", "R", "S", "T", "U", "F", "Kh", "Ts", "Ch", "Sh", "Shch", "", "Yu", "Ya", "a", "b", "v", "h", "d", "e", "e", "zh", "z", "y", "i", "i", "y", "k", "l", "m", "n", "o", "p", "r", "s", "t", "u", "f", "kh", "ts", "ch", "sh", "shch", "", "yu", "ya", " ", ".", ",", ":", ";", "!", "?", "(", ")", "-", "_", "+", "=", "*", "/", "%", "#", "@", "$", "&", "^", "№", "1", "2", "3", "4", "5", "6", "7", "8", "9", "0"];
    let result = "";
    for (let i = 0; i < text.length; i++) {
        result += latin[cyrillic.indexOf(text[i])];
    }
    return result;
}

export enum CitizenStatus {
    DCitizenStatus_1 = 1, // громадянин України
    DCitizenStatus_2 = 2 // іноземець
}


export enum VehicleType {
    "B1" = "B1",
    "B2" = "B2",
    "B3" = "B3",
    "B3_1" = "B3.1",
    "B3_2" = "B3.2",
    "B4" = "B4",
    "B5" = "B5",
    "A1" = "A1",
    "A2" = "A2",
    "C1" = "C1",
    "C2" = "C2",
    "D1" = "D1",
    "D2" = "D2",
    "F" = "F",
    "E" = "E"
}

export enum DPersonStatus {
    DPersonStatus_1, // фізична особа
    DPersonStatus_2, // юридична особа
}

export enum DPrivelege {
    DPrivelege_0, // без пільг
    DPrivelege_1, // пільговий
}

export enum BonusMalus {
    DBonusMalus_0,
    DBonusMalus_1,
    DBonusMalus_2,
    DBonusMalus_3,
    DBonusMalus_4,
    DBonusMalus_5,
    DBonusMalus_6,
    DBonusMalus_7,
    DBonusMalus_8,
    DBonusMalus_9,
    DBonusMalus_10,
    DBonusMalus_11,
    DBonusMalus_12,
}

export enum ExpLimit {
    DExpLimit_1, // 1 рік
}
export enum DVehicleType {
    DVehicleType_1,
    DVehicleType_2,
    DVehicleType_3,
    DVehicleType_4,
    DVehicleType_5,
    DVehicleType_6,
    DVehicleType_7,
    DVehicleType_8,
    DVehicleType_9,
    DVehicleType_10,
    DVehicleType_11,
    DVehicleType_12,
    DVehicleType_13,
    DVehicleType_14,
    DVehicleType_15,
    DVehicleType_16,
    DVehicleType_17,
}

export enum DPeriod {
    DPeriod_1, // 15 днів
    DPeriod_2, // 1 місяць
    DPeriod_3, // 2 місяці
    DPeriod_4, // 3 місяці
    DPeriod_5, // 4 місяці
    DPeriod_6, // 5 місяців
    DPeriod_7, // 6 місяців
    DPeriod_8, // 7 місяців
    DPeriod_9, // 8 місяців
    DPeriod_10, // 9 місяців
    DPeriod_11, // 10 місяців
    DPeriod_12, // 11 місяців
    DPeriod_13, // 12 місяців
    DPeriod_14, // 21 день
}

export enum DSphereUse {
    DSphereUse_1, // приватний
    DSphereUse_2, // таксі
}


export const getByValue = (enumType: any, value: number|string) => {
    return Object.keys(enumType).find(key => enumType[key] === value);
}

export const citizenStatusMapper = (citizen: string) => {
    return citizen === "UA" ? 1 : 2;
}

export const residentMapper = (citizen: string) => {
    return citizen === "UA";
}

export const zoneMapper = (zone: string) => {
    return zone === "ter2" ? 1 : 2;
}

export const autocivVehicleTypeMap = {
    [VehicleType.B1]: "DVehicleType_1",
    [VehicleType.B2]: "DVehicleType_2",
    [VehicleType.B3]: "DVehicleType_3",
    [VehicleType.B3_1]: "DVehicleType_3",
    [VehicleType.B3_2]: "DVehicleType_3",
    [VehicleType.B4]: "DVehicleType_4",
    [VehicleType.B5]: "DVehicleType_17",
    [VehicleType.A1]: "DVehicleType_5",
    [VehicleType.A2]: "DVehicleType_6",
    [VehicleType.C1]: "DVehicleType_7",
    [VehicleType.C2]: "DVehicleType_8",
    [VehicleType.D1]: "DVehicleType_9",
    [VehicleType.D2]: "DVehicleType_10",
    [VehicleType.F]: "DVehicleType_11",
    [VehicleType.E]: "DVehicleType_12"
}

export const vehicleTypeMapperToNumber = (vehicleType: string): number => {
    const vehicleTypes = {
        "DVehicleTypeGreenCardEnum_1": 1,
        "DVehicleTypeGreenCardEnum_2": 2,
        "DVehicleTypeGreenCardEnum_3": 3,
        "DVehicleTypeGreenCardEnum_5": 5,
        "DVehicleTypeGreenCardEnum_6": 6
    }
    return vehicleTypes[vehicleType as keyof typeof vehicleTypes];
}

export const vehicleTypeMapperPrintout = (vehicleType: string): string => {
    const vehicleTypes = {
        "DVehicleTypeGreenCardEnum_1": "A - Легковий автомобіль",
        "DVehicleTypeGreenCardEnum_2": "B - Мотоцикл",
        "DVehicleTypeGreenCardEnum_3": "C - Вантажний автомобіль",
        "DVehicleTypeGreenCardEnum_5": "E - Автобус",
        "DVehicleTypeGreenCardEnum_6": "F - Причіп або напівпричіп"
    }
    return vehicleTypes[vehicleType as keyof typeof vehicleTypes];
}


export const vehicleTypeMapperPrintoutOSCPV = (vehicleType: string): string => {
    const vehicleTypes = {
        "A1": "A1 - мотоцикли та моторолери до 300 см³ включно",
        "A2": "A2 - мотоцикли та моторолери понад 300 см³",
        "B1": "B1 - легковий автомобіль до 1600 см³",
        "B2": "B2 - легковий автомобіль від 1601 до 2000 см³",
        "B3": "B3 - легковий автомобіль від 2501 до 3000 см³",
        "B3.1": "B3 - легковий автомобіль від 2501 до 3000 см³",
        "B3.2": "B3 - легковий автомобіль від 2501 до 3000 см³",
        "B4": "B4 - легковий автомобіль понад 3001 см³",
        "B5": "B5 - легковий електромобіль",
        "F": "F - причепи до легкових автомобілів"
    }
    return vehicleTypes[vehicleType as keyof typeof vehicleTypes];
}

// const OTHER_CAR_MTSBU_ID = 11487;
const OTHER_PASSENGER_CAR_MTSBU_ID = 11486;
const OTHER_TRUCKS_MTSBU_ID = 11485;
const DEFAULT_VEHICLE_MODEL_ID = 0;
const OTHER_MOTO_MTSBU_ID = 11225;

export const getMarkByVehicleType = (vehicleType: string) => {
    switch (vehicleType) {
        case "Car":
            return OTHER_PASSENGER_CAR_MTSBU_ID;
        case "Motorcycle":
            return OTHER_MOTO_MTSBU_ID;
        case "Truck":
            return OTHER_TRUCKS_MTSBU_ID;
        default:
            return DEFAULT_VEHICLE_MODEL_ID;
    }



}

export const INSURANCE_SUM_DCV_TO_INSURANCE_SUM_DNV: Record<number, number> = {
    100000: 10000,
    150000: 10000,
    200000: 15000,
    500000: 20000,
    1000000: 20000,
    1500000: 30000,
    2000000: 40000,
    2500000: 50000
}

export const getInsuranceSumDNV = (insuranceSumDCV: number): number => {
    return INSURANCE_SUM_DCV_TO_INSURANCE_SUM_DNV[insuranceSumDCV];
}

export const getVariants = (city: string, insuranceSumDCV: number): string => {
    if (city === "Київ") {
        return {
            100000: "Варіант 1 Київ",
            150000: "Варіант 2 Київ",
            200000: "Варіант 3 Київ",
            500000: "Варіант 4 Київ",
            1000000: "Варіант 5 Київ",
            1500000: "Варіант 6 Київ",
            2000000: "Варіант 7 Київ",
            2500000: "Варіант 8 Київ"
        }[insuranceSumDCV] || "";
    } else {
        return {
            100000: "Варіант 1 Регіони",
            150000: "Варіант 2 Регіони",
            200000: "Варіант 3 Регіони",
            500000: "Варіант 4 Регіони",
            1000000: "Варіант 5 Регіони",
            1500000: "Варіант 6 Регіони",
            2000000: "Варіант 7 Регіони",
            2500000: "Варіант 8 Регіони"
        }[insuranceSumDCV] || "";
    }
    return "";
}

export const getMD = (insuranceSumDCV: number): number => {
    return {
        20000: 15000,
        27000: 20000,
        40000: 30000,
        80000: 60000,
        100000: 80000
    }[insuranceSumDCV] || 0;
}

export const getSL = (insuranceSumDCV: number): number => {
    return {
        20000: 5000,
        27000: 7000,
        40000: 10000,
        80000: 20000,
        100000: 20000
    }[insuranceSumDCV] || 0;
}

export const getTariffProgram = (insuranceSumDCV: number): string => {
    return `Захист ${insuranceSumDCV}`;
}

export const getEngineTypeByLabel = (label: string): { value: string, label: string } | null => {
    return {
        "Бензин": { value: "GASOLINE", label: "Бензин" },
        "Дизель": { value: "DIESEL", label: "Дизель" },
        "Газ": { value: "LPG", label: "Газ" },
        "Електричний": { value: "ELECTRIC", label: "Електричний" },
        "Гібрид": { value: "HYBRID", label: "Гібрид" },
    }[label] || null
}

export type AgeGroup =
  | 'ageFrom0To14'
  | 'ageFrom15To24'
  | 'ageFrom25To64'
  | 'ageFrom65To69'
  | 'ageFrom70To74';

export const detectAgeGroupName = (age: number): AgeGroup | undefined => {
    if (age < 15) return 'ageFrom0To14';
    if (age < 25) return 'ageFrom15To24';
    if (age < 65) return 'ageFrom25To64';
    if (age < 70) return 'ageFrom65To69';
    if (age < 75) return 'ageFrom70To74';
    return;
}

export const getSplitPassportData = (passportNumber: string): {
    documentSerie: string;
    documentNumber: string;
} => {
    if (!passportNumber) return { documentSerie: '', documentNumber: '' };
    const [documentSerie, documentNumber] =
      passportNumber?.split(/(?<=^[A-Za-zA-Яа-я]{2})/);
    return { documentSerie, documentNumber };
}

enum DPersonDocType {
    OTHER = 'DPersonDocType_0',
    PASSPORT = 'DPersonDocType_1',
    ID_CARD = 'DPersonDocType_2',
    DRIVER_LICENSE = 'DPersonDocType_3'
}

export const getPersonDocumentType = (documentType: string | null): string => {
    if (documentType === null) {
        return DPersonDocType.OTHER;
    }

    switch (documentType) {
        case 'PASSPORT':
            return DPersonDocType.PASSPORT;

        case 'INTERNAL_PASSPORT':
        case 'ID_CARD':
        case 'ID-CARD':
            return DPersonDocType.ID_CARD;

        case 'DRIVER_LICENSE':
            return DPersonDocType.DRIVER_LICENSE;

        default:
            return DPersonDocType.OTHER;
    }
};

export function determineDriverAge(minDriverAge: number | null, maxDriverAge: number | null): string {
    const minAge = Number(minDriverAge);
    const maxAge = Number(maxDriverAge);

    // Return "ageNoLimits" if either min or max age is less than 27
    if (minAge < 27 || maxAge < 27) {
        return "ageNoLimits";
    }

    // Return "age27NoLimits" if both min and max age are 27 or greater
    return "age27NoLimits";
}
